/**
 * The root element that displays a spinner before the app is mounted
 */
export const RootSkeleton = {
  QuerySelector: '.skeleton-container',
}

export const MediaElement = {
  QuerySelector: 'img',
  Attribute: 'data-media-id',
  CaptionTagName: 'FIGCAPTION',
  CaptionParentTagName: 'FIGURE',
  CKEditorSelector: 'figure',
  CKEditorTagName: 'FIGURE',
}

export const MediaLinkElement = {
  QuerySelector: 'a',
  TagName: 'A',
  ChildTagName: 'IMG',
  ChildAttribute: 'data-media-id',
}

export const MarkElement = {
  QuerySelector: 'span.marker',
  ClassName: 'marker',
  CKEditorSelector: 'mark',
  CKEditorTagName: 'MARK',
}

export const CodeBlockElement = {
  QuerySelector: 'pre',
  TagName: 'PRE',
}

export const UserMentionElement = {
  QuerySelector: 'a.sum-user-link.sm-link',
  Attribute: 'data-login',
}

export const UserGroupMentionElement = {
  QuerySelector: 'a.sum-user-link.sm-link',
  Attribute: 'data-users-group-uri',
}

export const UserGroupMentionAllElement = {
  QuerySelector: 'a.sum-user-link.sm-link',
  Attribute: 'data-audience',
}

export const Inline6WTagElement = {
  QuerySelector: 'a.s6m-tag-link.sm-link',
  Attribute: 'data-predicate',
}

export const Emoji = {
  QuerySelector: 'span.special-character',
  Attribute: 'data-emoji-unicode',
} as const

export const URLPreview = {
  QuerySelector: 'a.preview-link',
  TagName: 'A',
  BaseClassName: 'preview-link',
  TilePreviewClassName: 'tile-preview',
  TitlePreviewClassName: 'title-preview',
  ThumbnailPreviewClassName: 'thumbnail-preview',
} as const

export const ExternalUrlPreview = {
  ModelName: 'externalUrlPreview',
  BaseClassName: 'external-preview-link',
} as const

export const PlatformObjectPreview = {
  ModelName: 'platformObjectPreview',
  BaseClassName: 'platform-object-preview',
} as const

export const YoutubePreview = {
  ModelName: 'youtubePreview',
  BaseClassName: 'youtube-preview-link',
} as const

export const WidgetPreview = {
  ModelName: 'widgetPreview',
  BaseClassName: 'widget-preview-container',
} as const

export const URLPreviewActionButton = {
  ModelName: 'urlPreviewActionButton',
  BaseClassName: 'url-preview-link-action-button',
} as const
